
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { swapInPoint } = api;

@Component({
  components: { ItemForm },
})
export default class SwapInPointEdit extends Vue {
  @Prop({}) private id!: string;

  private form = {
    itmeId: null,
    itemName: null,
    itemLogo: null,
    descriptionUrl: null,
    serviceFee: null,
    serviceFeePercentage: null,
    incomePerPoint: null,
    link: null,
    categoryClasses: null,
    sort: 0,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await swapInPoint.itemEdit(form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: SwapInPointEdit) => void) => void,
  ) {
    const { id } = to.params;
    const { data } = await swapInPoint.itemGet(id);
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
